module.exports = "<ag-file-list [model]=\"'enterprise'\" [reference]=\"company\"></ag-file-list>\n"